import { useRequestPersistedStore, useRequestStore } from "entities/Request";
import { getRedirectRoute } from "entities/Request/utils/getRedirectRoute";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "ui";

function RejectRequestModal({ show, handleClose, rejectRequest, isRejecting }) {
  const { t } = useTranslation("Request");
  const navigate = useNavigate();
  const request = useRequestStore((state) => state.request);
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );
  const [rejectionComment, setRejectionComment] = useState("");
  const handleModalClose = () => {
    handleClose();
    setRejectionComment("");
  };
  const handleRequestRejection = () => {
    rejectRequest(rejectionComment).then((response) => {
      if (response) {
        handleClose();
        navigate(getRedirectRoute(viewRequestAs.role, request?.type));
      }
    });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("reason_of_rejection_modal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="reasonOfRejection">
          <Form.Label>{t("reason_of_rejection_modal.label")}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={rejectionComment}
            onChange={(e) => setRejectionComment(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={handleModalClose}>
          {t("reason_of_rejection_modal.close")}
        </Button>
        <Button
          variant="primary"
          onClick={handleRequestRejection}
          disabled={!rejectionComment.length || isRejecting}
          isLoading={isRejecting}
        >
          {t("reason_of_rejection_modal.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RejectRequestModal;
